<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
export default {
  data() {
    return {
      zh_CN
    };
  }
};
</script>
<style lang="less">
#app {
  height: 100%;
  // overflow: hidden;
}
// 最外层盒子
.body {
  height: 100%;
}
// confim样式覆盖
.ant-layout {
  background: #fff !important;
}
.ant-modal-body {
}
.ant-modal-content {
  margin: 40px;
}
.ant-modal-confirm-body > .anticon {
  display: none;
}
.ant-modal-confirm-title {
  text-align: center;
  line-height: 90px !important;
}
.ant-modal-confirm .ant-modal-body {
  padding: 0 !important;
}
.ant-modal-confirm-body-wrapper {
  height: 150px;
}
.ant-modal-confirm .ant-modal-confirm-btns {
  float: none !important;
  margin-top: 20px !important;
}
.ant-modal-confirm-btns {
  display: flex;
}
.ant-modal-confirm-btns > .ant-btn {
  width: 50%;
  height: 40px;
  border-radius: 0 !important;
  margin: 0 !important;
}
</style>
